export const AmbassadorContentHero = {
  HERO_TITLE: 'Interested in becoming a WALDO ambassador?',
  HERO_CONTENT:
    'Click the button below to get in touch, or scroll down to read more about our doctor ambassador program.',
  HERO_CTA: 'BECOME AN AMBASSADOR',
};
